import { render, staticRenderFns } from "./NutritionDetailReport.vue?vue&type=template&id=4b0ea5dc&scoped=true&"
import script from "./NutritionDetailReport.vue?vue&type=script&lang=js&"
export * from "./NutritionDetailReport.vue?vue&type=script&lang=js&"
import style0 from "./NutritionDetailReport.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./NutritionDetailReport.vue?vue&type=style&index=1&id=4b0ea5dc&scoped=true&lang=scss&"
import style2 from "./NutritionDetailReport.vue?vue&type=style&index=2&lang=css&"
import style3 from "./NutritionDetailReport.vue?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0ea5dc",
  null
  
)

export default component.exports